<template>
  <div class="warp">
    <BaseHeader />

    <main v-if="!isExp">
      <SideLeft />

      <div id="payment">
        <figure v-if="!section">
          <div class="topic text-blue titillium-sb">{{ text.paymentType }}</div>
          <form>
            <ul class="container-check" style="padding-left: unset !important">
              <li v-for="(pm, index) in payment_methods" :key="index">
                <label :class="{ text_deactive: pm.disabled, 'b-check': true }">
                  <input
                    type="radio"
                    name="payment-choice"
                    :value="pm.paymentType"
                    :disabled="pm.disabled"
                    v-model="selectedMethod"
                  />
                  <span class="checkmark"></span>
                  <div class="text">
                    <p class="titillium-r">{{ pm.description }}</p>
                    <!-- <p class="titillium-r">{{ pm.title }}</p>
                              <i :class=" {'titillium-l':true, text_deactive : pm.disabled}">{{ pm.desc }}</i> -->
                  </div>
                  <em v-html="pm.icon"></em>
                </label>
              </li>
            </ul>
          </form>
        </figure>

        <a
          v-if="!section"
          :class="{ deactive: !selectedMethod, 'btn titillium-sm': true }"
          :disabled="!selectedMethod"
          @click="set_section()"
          >{{ text.nextButton }} <em></em
        ></a>

        <figure v-if="section && paymentBy.length > 0">
          <div class="topic text-blue titillium-sb">{{ text.paymentBy }}</div>
          <form>
            <ul class="container-check" style="padding-left: unset !important">
              <li>
                <div style="text-align: center">
                  <h4>{{ paymentBy[0].title }}{{ paymentBy[0].desc }}</h4>
                  <div
                    style="margin-left: 8px"
                    v-html="paymentBy[0].icon"
                  ></div>
                </div>
              </li>
              <li v-if="paymentBy.length > 1">
                <div style="text-align: center">
                  <a href="#" @click="section = ''" style="color: #0d6efd">{{
                    text.changePaymentMethod
                  }}</a>
                </div>
              </li>
              <!-- QR CODE -->
              <li
                v-if="
                  paymentGroup0.includes(selectedMethod) ||
                  paymentGroup1.includes(selectedMethod)
                "
              >
                <div
                  class="text-center"
                  style="padding: 0 15%; padding-bottom: 0px"
                >
                  <v-img id="download-qr" :src="qrcode" />
                  <a
                    v-if="
                      (section &&
                        paymentBy.length > 0 &&
                        paymentGroup0.includes(selectedMethod)) ||
                      paymentGroup1.includes(selectedMethod)
                    "
                    class="btn titillium-sm mt-3"
                    style="padding-right: 46px"
                    @click="downloadQR()"
                  >
                    {{ text.btndownloadQR }}</a
                  >
                </div>
              </li>

              <!-- QR DESC -->
              <li
                v-if="
                  paymentGroup0.includes(selectedMethod) ||
                  paymentGroup1.includes(selectedMethod)
                "
              >
                <div class="text-center">
                  <h4>{{ text.headQr }}</h4>
                  <p>{{ text.headQrdesc }}</p>
                </div>
                <div class="download-qr"></div>
              </li>

              <!-- CREDIT -->
              <li v-if="paymentGroup2.includes(selectedMethod)">
                <div class="text-center" style="padding: 50px">
                  <h4>{{ text.headCredit }}</h4>
                  <p>{{ text.headCreditdesc }}</p>
                  <v-text-field
                    outline
                    label="จำนวนเงิน"
                    placeholder="จำนวนเงิน"
                    type="number"
                    v-model="amountCredit"
                    single-line
                    @blur="checkAmount"
                    :maxlength="total_price"
                  ></v-text-field>
                </div>
                <div class="text-center">
                  <a
                    style="color: #0d6efd"
                    v-if="
                      amountCredit != total_price &&
                      paymentGroup2.includes(selectedMethod)
                    "
                    @click="fullPaid"
                    disabled
                  >
                    {{ text.fullpaid }}
                  </a>
                </div>
              </li>

              <!-- SCB Easy -->
              <li v-if="paymentGroup3.includes(selectedMethod)">
                <div class="text-center" style="padding: 50px">
                  <img
                    src="/images/ic_scb_easy.jpg"
                    alt="ic_scb_easy"
                    style="width: 100%"
                  />
                </div>
              </li>

              <!-- payment detail -->
              <li>
                <div class="row mb-4">
                  <div class="col-6 lable">
                    <h4>{{ text.amountTotal }}</h4>
                  </div>
                  <div class="col-6 text-end info">
                    <h4>
                      <strong>{{ amount }}</strong>
                    </h4>
                  </div>
                </div>
                <div v-if="outstanding > 0" class="row">
                  <div class="col-6 lable text-red">
                    <h4>{{ text.outstanding }}</h4>
                  </div>
                  <div class="col-6 text-end text-red">
                    <h4>
                      <strong>{{ outstanding }}</strong>
                    </h4>
                  </div>
                </div>
              </li>
            </ul>
          </form>
        </figure>

        <a
          v-if="
            section &&
            paymentBy.length > 0 &&
            paymentGroup2.includes(selectedMethod)
          "
          class="btn titillium-sm"
          @click="sendPayment()"
        >
          {{ text.nextButton }} <em></em
        ></a>
      </div>
    </main>
    <main v-else>
      <div class="col-lg-6 offset-lg-3">
        <div class="card-v2">
          <div class="card-head-v2">
            <p class="text-center pm-amount">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="11" cy="11" r="11" fill="#AB2328" />
                <path
                  d="M9.992 17V9H12.136V17H9.992ZM9.992 7.976V5.8H12.136V7.976H9.992Z"
                  fill="white"
                />
              </svg>
              {{ text.linkExp }}
            </p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<style>
.v-input__slot {
  margin-bottom: 0px !important;
}
.remark {
  margin-bottom: 20px;
  color: #004071;
}
</style>
<script>
import * as moment from 'moment'
import axios from 'axios'
import { mapState } from 'vuex'
import domtoimage from 'dom-to-image'
import PaymentService from '@/services/PaymentService.js'
export default {
  mounted() {
    // check Expire date
    // let checkExpire = setInterval(() => {
    //   if (sessionStorage.getItem('linkcode')) {
    //     const exp = moment(this.$store.state.expire).toDate()
    //     if (exp.getTime() <= new Date().getTime()) {
    //       this.isExp = true
    //       this.dialog = true
    //       clearInterval(checkExpire)
    //     }
    //   }
    // }, 10000)
    const linkcodes = this.$route.query.linkcode.split('?')
    this.$route.query.linkcode = linkcodes[0]
    this.$store.dispatch('getBillData', {
      linkcode: this.$route.query.linkcode,
      page: 'paymentmethods',
    })

    this.checkData()
  },
  data() {
    return {
      selectedMethod: null,
      isExp: false,
      dialog: false,
      section: '',
      /*
      ThaiQR        /qr/ThaiQR/?linkcode=LETOLE,
      CreditCard    /paymentInput/CreditCard/?linkcode=LETOLE,
      CreditUnion   /credit/CreditUnion/?linkcode=LETOLE,
      CreditQR      /qr/CreditQR/?linkcode=LETOLE,
      WeChat        /qr/WeChat/?linkcode=LETOLE,
      Alipay        /qr/Alipay/?linkcode=LETOLE,
      SCB Easy      /scbeasy/SCB Easy/?linkcode=LETOLE,
      */
      paymentBy: {},
      paymentGroup0: ['ThaiQR'],
      paymentGroup1: ['CreditQR', 'WeChat', 'Alipay'],
      paymentGroup2: ['CreditCard', 'CreditUnion'],
      paymentGroup3: ['SCB Easy'],

      // CREDTI CARD
      minPay: {
        amount: 0,
        disabled: false,
      },
      billBankLength: 0,
    }
  },
  created() {
    this.getBanks()
  },
  methods: {
    set_section() {
      this.loading = true
      this.section = this.selectedMethod

      this.paymentBy = this.payment_methods.filter((res) => {
        return res.paymentType == this.selectedMethod
      })

      if (this.paymentGroup0.includes(this.selectedMethod)) {
        this.genQr()
      } else if (this.paymentGroup1.includes(this.selectedMethod)) {
        this.genQr()
      } else if (this.paymentGroup2.includes(this.selectedMethod)) {
        // CLICK SENDPAYMENT
      } else if (this.paymentGroup3.includes(this.selectedMethod)) {
        window.location.href = this.route
      }
    },

    genQr() {
      let billStatus = setInterval(() => {
        this.$store
          .dispatch('getBillDataStatus', this.$route.query.linkcode)
          .then(() => {
            if (this.$store.state.billDataStatus != 2) {
              let page =
                this.$store.state.billDataStatus <= 3
                  ? 'paymentMethods'
                  : 'billRecieve'
              clearInterval(billStatus)
              this.$router.push(
                `/${page}/?linkcode=${this.$route.query.linkcode}`
              )
            }
          })
      }, 30000)
      if (this.$store.state.billBank) {
        var bank = this.$store.state.billBank.filter((item) => {
          return item.paymentType == this.selectedMethod
        })
        if (bank.length > 0) {
          let qr = {}
          switch (this.selectedMethod) {
            case 'CreditQR':
              this.method = 'คิวอาร์ เครดิต'
              break
            case 'ThaiQR':
              this.method = 'คิวอาร์ เพย์เมนต์'
              break
            case 'WeChat':
              this.method = 'WeChat Pay'
              qr.trantype = 'W'
              break
            case 'Alipay':
              this.method = 'Ali Pay'
              qr.trantype = 'A'
              break
          }
          qr.method = this.selectedMethod
          qr.refcode = this.$store.state.linkcode
          qr.amount = this.$store.state.amount
          qr.bubankid = bank[0].id
          qr.updateQr = this.$store.state.qr
          this.$store.dispatch('getQR', qr)
        }
      } else {
        this.$router.push(
          '/paymentMethods/?linkcode=' + this.$route.query.linkcode
        )
      }
      this.loading = false
    },
    downloadQR() {
      this.loading = true
      domtoimage
        .toJpeg(document.getElementById('download-qr'), {
          quality: 0.95,
        })
        .then((dataUrl) => {
          var link = document.createElement('a')
          let urlString = window.location.href
          link.download = urlString.split('?')[1].split('=')[1] + '.jpg'
          link.href = dataUrl
          link.click()
          this.loading = false
        })
    },

    checkData() {
      try {
        if (sessionStorage.getItem('linkcode')) {
          const exp = moment(this.$store.state.expire).toDate()
          if (exp.getTime() <= new Date().getTime()) {
            this.isExp = true
            this.dialog = true
          } else if (
            this.$store.state.billData.status > 3 &&
            this.$store.state.billData.total == this.$store.state.billData.paid
          ) {
            this.$router.push(
              `/billRecieve/?linkcode=${this.$route.query.linkcode}`
            )
          }
          if (this.$store.state.billBank.length == 1) {
            this.nextSkip()
          }
        } else {
          this.$router.push(`/authen/?linkcode=${this.$route.query.linkcode}`)
        }
      } catch (error) {
        // console.log(error)
        this.autoNext()
      }
    },
    onLinkExpire() {
      this.$router.push(`/authen/?linkcode=${this.$route.query.linkcode}`)
    },
    getBanks() {
      if (this.$store.state.billBank) {
        let banks = this.$store.state.billBank
        this.selectedMethod = banks[0].paymentType
        this.billBankLength = banks.length
      }
    },

    async autoNext() {
      const linkcodes = this.$route.query.linkcode.split('?')
      this.$route.query.linkcode = linkcodes[0]
      await this.$store.dispatch('getBillData', {
        linkcode: this.$route.query.linkcode,
        page: 'paymentmethods',
      })
      try {
        if (!this.section && this.$store.state.billBank.length == 1) {
          let banks = this.$store.state.billBank
          this.selectedMethod = banks[0].paymentType
          this.set_section()
        }
      } catch (error) {
        this.autoNext()
      }
    },

    nextSkip() {
      if (this.billBank.length) {
        this.isExp = false
        let path = ''
        let banks = this.$store.state.billBank
        let selectedBank = banks.filter((bank) => {
          return bank.paymentType == this.selectedMethod
        })[0]
        if (selectedBank) {
          if (selectedBank.splitCard) {
            path = 'paymentInput'
          } else if (selectedBank.paymentType === 'SCB Easy') {
            path = 'scbeasy'
          } else {
            if (
              selectedBank.paymentType == 'CreditCard' ||
              selectedBank.paymentType == 'CreditUnion'
            ) {
              path = 'credit'
            } else {
              path = 'qr'
            }
            this.$store.commit('MAX_AMOUNT')
          }
          this.$store.commit('SELECTED_METHOD', selectedBank.id)
        }
        //NEW ACTION
        this.selectedMethod = selectedBank.paymentType
        this.set_section()
        //OLD ACTION
        // this.$router.push(
        //   `/${path}/${this.selectedMethod}/?linkcode=${
        //     this.$route.query.linkcode
        //   }`
        // )
      }
    },

    fullPaid() {
      this.amountCredit = this.total_price
    },
    checkAmount() {
      if (
        parseFloat(this.amount) > this.total_price ||
        parseFloat(this.amount) < 0
      ) {
        this.amountCredit = this.total_price
      }
    },
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    },

    sendPayment() {
      this.checkAmount()
      let banks = this.$store.state.billBank.filter((res) => {
        return res.paymentType == this.selectedMethod
      })[0]
      let bubankid = banks.id
      let data = {
        linkcode: this.$route.query.linkcode,
        invoiceNo: this.$route.query.linkcode + '_' + new Date().getTime(),
        amount: this.amountCredit,
        description: 'ค่ารักษาพยาบาล',
        currencyCode: 'THB',
        paymentChannel: '',
        locale: 'th',
        tokenize: 'true',
        cardTokens: this.cardTokens,
        userDefined1: this.$route.query.linkcode,
        userDefined2: this.ref1,
        userDefined3: bubankid,
        userDefined4: '',
        userDefined5: '',
        frontendReturnUrl: '',
        backendReturnUrl: '',
        nonceStr: '' + new Date().getTime(),
      }
      const options = {
        headers: {
          'content-type': 'application/json',
        },
        // data: JSON.stringify(data)
        data: data,
      }
      this.$store.dispatch('getTwocTwopIntegrate', data).then(() => {
        //getTwocTwopIntegrate
      })
    },
  },
  computed: {
    qrcode() {
      if (!this.$store.state.qr) return require('@/assets/no_img.png')
      return this.$store.state.qr
    },

    ...mapState({
      billBank: (state) => state.billBank,
    }),
    titlePaymentType() {
      return this.$options.filters.dbTextDisplay('PaymentType')
    },
    payment_methods() {
      if (this.$store.state.billBank) {
        let banks = this.$store.state.billBank
        let isiOS =
          navigator.userAgent.match('iPad') ||
          navigator.userAgent.match('iPhone') ||
          navigator.userAgent.match('iPod')
        let isAndroid = navigator.userAgent.match('Android')
        banks.forEach((bank) => {
          bank.disabled = false
          if (this.$store.state.language == 'EN') {
            bank.description = bank.description_en
          } else {
            bank.description = bank.description_th
          }
          switch (bank.paymentType) {
            case 'CreditCard':
              bank.icon = `<img src="${require('../assets/ic_Master.png')}" height="20"/>&nbsp;&nbsp;<img src="${require('../assets/Ic_Visa.png')}" height="20"/>&nbsp;<img src="${require('../assets/ic_Jcb.svg')}" height="20"/>`
              break
            case 'CreditUnion':
              bank.icon = `<img src="${require('../assets/Ic_Union.svg')}" height="20"/>`
              break
            case 'CreditQR':
              bank.icon = `<img src="${require('../assets/ic_QR.svg')}" height="20"/>`
              break
            case 'ThaiQR':
              bank.icon = `<img src="${require('../assets/thai_qr.png')}" height="20"/>&nbsp;&nbsp;<img src="${require('../assets/prompt_pay.png')}" height="20"/>`
              break
            case 'WeChat':
              bank.icon = `<img src="${require('../assets/Ic_WeChat.svg')}" height="20"/>`
              break
            case 'Alipay':
              bank.icon = `<img src="${require('../assets/ic_Alipay.svg')}" height="20"/>`
              break
            case 'SCB Easy':
              bank.disabled = !(isiOS || isAndroid)
              bank.icon = `<img src="${require('../assets/ic_scb_easy.jpg')}" height="20"/>`
              break
          }
        })
        return banks
      } else {
        return []
      }
    },
    // payment_methods() {
    //   if (this.$store.state.billBank) {
    //     let banks = this.$store.state.billBank
    //     let isiOS =
    //       navigator.userAgent.match('iPad') ||
    //       navigator.userAgent.match('iPhone') ||
    //       navigator.userAgent.match('iPod')
    //     let isAndroid = navigator.userAgent.match('Android')
    //     banks.forEach(bank => {
    //       bank.disabled = false
    //       if (this.$store.state.language == 'EN') {
    //         bank.description = bank.description_en
    //       } else {
    //         bank.description = bank.description_th
    //       }
    //       let name = {}
    //       if (this.$store.state.language == 'TH') {
    //         name = {
    //           CreditCard_title : `บัตรเดบิต / เครดิต`,
    //           CreditCard_desc : `วีซ่า / มาสเตอร์ / เจซีบี (บัตรหลายใบ)`,
    //           CreditUnion_title : `บัตรเครดิต ยูเนี่ยน`,
    //           CreditUnion_desc : ``,
    //           CreditQR_title : `คิวอาร์ เครดิต`,
    //           CreditQR_desc : `(จ่ายบัตร Visa ด้วย QR)` ,
    //           ThaiQR_title : `Mobile Banking / คิวอาร์ เพย์เมนต์`,
    //           ThaiQR_desc : ``,
    //           WeChat_title : `Wechat Pay`,
    //           WeChat_desc : ``,
    //           Alipay_title : `Alipay`,
    //           Alipay_desc : ``,
    //           SBC_title : `ผ่อนชำระ 0%  3 เดือน`,
    //           SBC_desc : `เฉพาะบัตรเครดิต SCB  และทำรายการผ่าน SCB Easy App เท่านั้น`,
    //         }
    //       } else {
    //         name = {
    //           CreditCard_title : `Debit/Credit Card`,
    //           CreditCard_desc : `(Pay more than 1 card)`,
    //           CreditUnion_title : `Union Pay Card (Split Card)`,
    //           CreditUnion_desc : ``,
    //           CreditQR_title : `QR Credit (Visa QR)`,
    //           CreditQR_desc : `(Pay with Visa card by QR)` ,
    //           ThaiQR_title : `Mobile Banking / PromptPay`,
    //           ThaiQR_desc : ``,
    //           WeChat_title : `Wechat Pay`,
    //           WeChat_desc : ``,
    //           Alipay_title : `Alipay`,
    //           Alipay_desc : ``,
    //           SCB_title : `Installment payment 0% 3 months`,
    //           SCB_desc : `Only for SCB credit cards and transactions via SCB Easy App only.`,
    //         }
    //       }
    //       switch (bank.paymentType) {
    //         case 'CreditCard':
    //           bank.title = name.CreditCard_title
    //           bank.desc = name.CreditCard_desc
    //           bank.icon = `<img src="/images/icon-card.png" alt="Card">`
    //           break
    //         case 'CreditUnion':
    //           bank.title = name.CreditUnion_title
    //           bank.desc = name.CreditUnion_desc
    //           bank.icon = `<img src="/images/icon-unionpay.png" alt="unionpay">`
    //           break
    //         case 'CreditQR':
    //           bank.title = name.CreditQR_title
    //           bank.desc = name.CreditQR_desc
    //           bank.icon = `<img src="/images/icon-qr.png" alt="QR">`
    //           break
    //         case 'ThaiQR':
    //           bank.title = name.ThaiQR_title
    //           bank.desc = name.ThaiQR_desc
    //           bank.icon = `<img src="/images/icon-qr-payment.png" alt="Card">`
    //           break
    //         case 'WeChat':
    //           bank.title = name.WeChat_title
    //           bank.desc = name.WeChat_desc
    //           bank.icon = `<img src="/images/icon-wechat.png" alt="Wechat">`
    //           break
    //         case 'Alipay':
    //           bank.title = name.Alipay_title
    //           bank.desc = name.Alipay_desc
    //           bank.icon = `<img src="/images/icon-alipay.png" alt="Alipay">`
    //           break
    //         case 'SCB Easy':
    //           bank.title = name.SCB_title
    //           bank.desc = name.SCB_desc
    //           bank.disabled = !(isiOS || isAndroid)
    //           bank.icon = `<img src="/images/icon-scb.png" alt="SCB">`
    //           break
    //       }
    //     })
    //     return banks
    //   } else {
    //     return []
    //   }
    // },
    isSplitPaid() {
      if (
        this.$store.state.billData &&
        this.$store.state.billData.paid > 0 &&
        this.$store.state.billData.outstanding > 0
      ) {
        return true
      } else {
        return false
      }
    },
    route() {
      if (this.$store.state.billBank) {
        let path = ''
        let banks = this.$store.state.billBank
        let selectedBank = banks.filter((bank) => {
          return bank.paymentType == this.selectedMethod
        })[0]
        if (selectedBank) {
          if (selectedBank.splitCard) {
            path = 'paymentInput'
          } else if (selectedBank.paymentType === 'SCB Easy') {
            path = 'scbeasy'
          } else {
            if (
              selectedBank.paymentType == 'CreditCard' ||
              selectedBank.paymentType == 'CreditUnion'
            ) {
              path = 'credit'
            } else {
              path = 'qr'
            }
            this.$store.commit('MAX_AMOUNT')
          }
          this.$store.commit('SELECTED_METHOD', selectedBank.id)
        }
        return `/${path}/${this.selectedMethod}/?linkcode=${this.$route.query.linkcode}`
      }
      return '/'
    },

    text() {
      let obj = {}
      if (this.$store.state.language == 'TH') {
        obj = {
          paymentType: 'เลือกวิธีการชำระเงิน',
          nextButton: 'ดำเนินการต่อ',
          linkExp: 'ลิงค์ชำรเงินนี้หมดอายุแล้ว',
          paymentBy: 'ชำระผ่าน',
          changePaymentMethod: 'เปลี่ยนวิธีการชำระเงิน',
          btndownloadQR: 'บันทึกคิวอาร์โค้ด',
          amountTotal: 'ยอดที่ระบุ',
          outstanding: 'จะเหลือยอดค้างชำระ',
          headQr: 'กรุณาสแกนคิวอาร์ เพื่อชําระเงิน',
          headQrdesc:
            'โปรดรอซักครู่ กรุณาอย่าปิดเบราว์เซอร์ หรือทําการรีเฟรช หน้าจอหลังชําาระเงินแล้ว ระบบจะทําการพาคุณกลับสู่หน้าหลัก',
          headCredit: 'ระบุจำนวนเงินที่ต้องชำระ',
          headCreditdesc:
            'ชำระเงินมากกว่า 1 บัตร กรุณาทำรายการ 1 รายการต่อครั้ง โดยระบุจำนวนเงินที่ต้องชำระสำหรับบัตรแต่ละใบ',
          fullpaid: 'ชำระเต็มจำนวน',
        }
      } else {
        obj = {
          paymentType: 'Payment Type',
          nextButton: 'Next',
          linkExp: 'This link expire.',
          paymentBy: 'Pay through',
          changePaymentMethod: 'Change payment method',
          btndownloadQR: 'Save QR ',
          amountTotal: 'Amount ',
          outstanding: 'Outstanding',
          headQr: 'Please scan the QR. to pay',
          headQrdesc:
            'Please wait a moment. Please do not close the browser. or refresh Screen after payment The system will take you back to the home page. ',
          headCredit: 'Specific the amount to pay',
          headCreditdesc:
            'Pay more than 1 card, please make 1 transaction at a time, specifying the amount to pay for each card. ',
          fullpaid: 'Pay in full',
        }
      }
      return obj
    },

    amount() {
      return this.twoDecimal(this.$store.state.amount)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    amountCredit: {
      get() {
        return this.$store.state.amount
      },
      set(newValue) {
        newValue = parseFloat(newValue)
        if (!newValue) newValue = 0
        if (newValue > this.minPay.amount) {
          this.minPay.disabled = false
        } else {
          this.minPay.disabled = true
        }
        this.$store.dispatch('changeAmount', newValue)
      },
    },

    total_price() {
      return this.$store.state.outstanding
    },
    outstanding() {
      return this.twoDecimal(
        this.$store.state.outstanding - this.$store.state.amount
      )
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    cardTokens() {
      return this.$store.state.cardTokens
    },
    ref1() {
      return this.$store.state.ref1
    },
  },
}
</script>
<style scoped>
@media only screen and (max-width: 576px) {
  .b-check em {
    scale: unset;
  }
}
@media only screen and (max-width: 414px) {
  .b-check em {
    scale: unset;
  }
}
</style>
